import { get } from '../libs/http'

export function hospitalList (data) {
	return get('/home/hospitalList', data)
}

export function monitorData (data) {
	return get('/home/monitorData', data)
}

export function getViewToken (data) {
	return get('/bimface/getViewToken', data)
}
